// extracted by mini-css-extract-plugin
export var emailBlockLink = "_km-0";